import React from 'react';

import ExpertMenuItem from './components/MainNavigation/components/WebMenu/components/ExpertMenuItem';
import LinkMenuItem from './components/MainNavigation/components/WebMenu/components/LinkMenuItem';
import MarketMenuItem from './components/MainNavigation/components/WebMenu/components/MarketMenuItem';

import NestedMarketMenu from './components/MainNavigation/components/MobileMenu/components/NestedMarketMenu';
import NestedExpertMenu from './components/MainNavigation/components/MobileMenu/components/NestedExpertMenu';
import NestedProfileMenu from './components/MainNavigation/components/MobileMenu/components/NestedProfileMenu';
import { User } from '@redux-modules/user/interfaces';
import getConfig from 'next/config';

export type MenuOption = {
  translationKey: string;
  activeRoutePrefixes?: string[];
  link?: string;
  target?: string;
  external?: boolean;
  dataAnalyticsId?: string;
  leftIcon?: string;
  leftActiveIcon?: string;
  enabled?: boolean;
};

export type WebMenuOption = {
  Component: React.FC<{ option: WebMenuOption }>;
} & MenuOption;

export type MobileMenuOption = {
  NestedComponent?: React.FC;
  hideExpandIcon?: boolean;
} & MenuOption;

const getOptions: (user: User) => MenuOption[] = user => [
  {
    translationKey: 'menus.dashboard',
    activeRoutePrefixes: ['/cockpit'],
    link: 'cockpit',
    enabled: user?.onboarded
  },
  {
    translationKey: 'menus.exploreMarkets',
    activeRoutePrefixes: ['/markets'],
    enabled: user?.onboarded
  },
  {
    translationKey: 'globalNav.supplierSourcing',
    activeRoutePrefixes: ['/supplier-sourcing'],
    link: 'supplier-sourcing?q=*&_semc=grouped',
    enabled: user?.supsInfrastructure === 'yes'
  },
  {
    translationKey: 'menus.businessOpportunities',
    activeRoutePrefixes: ['/business'],
    link: 'business-opportunities',
    dataAnalyticsId: '114-menu',
    enabled: user?.onboarded
  },
  {
    translationKey: 'menus.toolsResources',
    activeRoutePrefixes: ['/posting-of-employees'],
    dataAnalyticsId: '62-tools-and-ressources-click-menu-item',
    enabled: user?.onboarded
  }
];

export const getMobileOptions: (user: User) => MobileMenuOption[] = user => {
  const options = getOptions(user);
  return [
    {
      ...options[0]
    },
    {
      ...options[1],
      NestedComponent: NestedMarketMenu
    },
    {
      ...options[2]
    },
    {
      ...options[3]
    },
    {
      ...options[4],
      NestedComponent: NestedExpertMenu
    }
  ];
};

export const additionalMobileOptions = (locale: string): MobileMenuOption[] => [
  {
    translationKey: 'globalNav.contact',
    leftIcon: 'contactOnWhiteSecondary',
    leftActiveIcon: 'contactPrimary',
    link: 'mailto:dpi@s-ge.com',
    external: true
  },
  {
    translationKey: 'menus.profile',
    activeRoutePrefixes: ['/profile'],
    leftIcon: 'userOnWhiteSecondary',
    leftActiveIcon: 'userPrimary',
    NestedComponent: NestedProfileMenu,
    hideExpandIcon: true
  },
  {
    translationKey: 'globalNav.backToHomepage',
    leftIcon: 'switchOnWhiteSecondary',
    leftActiveIcon: 'switchPrimary',
    NestedComponent: NestedProfileMenu,
    link: `${getConfig().publicRuntimeConfig.SGE_UNIFY_URL}/export/${locale}`,
    hideExpandIcon: true
  }
];

export const getWebOptions: (user: User) => WebMenuOption[] = user => {
  const options = getOptions(user);
  return [
    {
      ...options[0],
      Component: LinkMenuItem
    },
    {
      ...options[1],
      Component: MarketMenuItem
    },
    {
      ...options[2],
      Component: LinkMenuItem
    },
    {
      ...options[3],
      Component: LinkMenuItem
    },
    {
      ...options[4],
      Component: ExpertMenuItem
    }
  ];
};

export const userMenuOptions: MenuOption[] = [
  {
    translationKey: 'preferencesUrl',
    leftIcon: 'preferencesOnWhiteSecondary',
    leftActiveIcon: 'preferencesPrimary',
    link: 'profile'
  },
  {
    translationKey: 'marketsUrl',
    leftIcon: 'starOnWhiteSecondary',
    leftActiveIcon: 'starPrimary',
    link: 'explore-markets'
  },
  {
    translationKey: 'productsUrl',
    leftIcon: 'cubeOnWhiteSecondary',
    leftActiveIcon: 'cubePrimary',
    link: 'profile#user-products'
  }
];
